<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="سميرة-حمادي">
<h1 style="font-family:Dubai"><span dir="rtl">سميرة حمادي</span></h1>
<p style="text-indent:0em"><span dir="rtl">سميرة حمادي، كاتبة، ومُستشارة في (الإتيكيت)، ومُدرِّبةُ حياةٍ مُعتَمَدة مِن معهَد (إميلي بوست).</span></p><br/>
<p style="text-indent:0em"><span dir="rtl">هي أيضًا مُؤسِّسةُ شركةِ استشاراتِ (الإتيكيت) الحديثة؛ حيثُ تُقدِّم استشاراتٍ وتدريباتٍ للمؤسَّسات والأفرادِ مِن جميع الأعمارِ حولَ فنِّ (الإتيكيت)، والمهاراتِ الشّخصيَّةِ، بالإضافة إلى ذلك، هي أيضًا طيَّارةٌ مُعترَفٌ بها.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?1687e6ad